import AllResorts from './components/AllResorts';

const ratesJSON = sandals_app.page.results.minimumRates;

const resorts = sandals_app.page.resorts.map(resort => {
    return {
        city: resort.resortCity,
        country: resort.countryName,
        countryCode: resort.countryCode,
        link: resort.resortUrl,
        name: resort.resortShortname,
        rstCode: resort.rstCode,
        shortWebDescription: resort.resortWebDescription,
    };
});

const staticActivities = {
    lively: ['SMB', 'SGO', 'SGL', 'SAT', 'SBD', 'SBR','SDR'],
    innovative: ['SMB', 'SWH', 'SLS', 'SBD', 'SBR'],
    laidback: ['SRC', 'SNG', 'SWH', 'SRB', 'SEB', 'SLU', 'SHC', 'SCR'],
    casual: ['SRC', 'SGO', 'SGL'],
    intimate: ['SNG', 'BRP', 'SHC', 'SLS'],
    elegant: ['BRP', 'SRB', 'SEB', 'SLU', 'SAT', 'SCR','SDR'],
    golf: ['SGO', 'BRP', 'SLU', 'SHC', 'SGL', 'SEB', 'SCR'],
    scuba: ['SGO', 'SLS', 'SWH', 'SNG', 'SAT', 'SEB', 'SRB', 'SGL', 'SMB', 'SCR'],
    tennis: ['SEB', 'SWH', 'SRB', 'SGO', 'SAT', 'SLU', 'SMB', 'SRC', 'SCR'],
    meeting: ['SEB', 'SRB', 'SAT', 'SGL', 'SWH', 'SGO', 'SBR', 'SCR'],
    wedding: ['SMB', 'SRC', 'SNG', 'SWH', 'SGO', 'BRP', 'SRB', 'SEB', 'SLU', 'SGL', 'SHC', 'SAT', 'SLS', 'SBD', 'SBR','SSV'],
};
const features = sandals_app.page.results.featureQuestions;
const slideImages = sandals_app.page.results.sliderData.resortsSlider;
const questionsAnswersWithResorts = sandals_app.page.results.questionsAnswersWithResorts;
const questionPopups = sandals_app.page.results.questionPopups;

const filterData = [
    {
        label: 'Sort by Location',
        value: 'ALPHABETICAL',
    },
    {
        label: 'Price: Low to High',
        value: 'LOWTOHIGH',
    },
    {
        label: 'Price: High to Low',
        value: 'HIGHTOLOW',
    },
];

const countryCodes = () => {
    const reducer = (count, resort) => {
        const countryCode = resort.countryCode;

        if (!count[countryCode]) {
            count[countryCode] = 1;
        } else {
            count[countryCode]++;
        }

        return count;
    };

    const names = resorts.reduce(reducer, {});

    return Object.keys(names);
};

// handle keyboard actions
window.addEventListener('keydown', (e) => {
    if (e.keyCode === 13) {
        if (e.target.classList.contains('checkbox')) {
            e.target.click();
        }
        if (e.target.classList.contains('resetButton')) {
            e.target.click();
        }
        if (e.target.classList.contains('slider-arrow')) {
            e.target.click();
        }

        if (e.target.classList.contains('gcvCountryField')) {
            console.log('dropdown in');
            // document.getElementById('footer-form').preventDefault();
            e.target.click();
            // e.target.dispatchEvent('mousedown');
        }
    }
});

const activityNamesUsing = ['golf', 'scuba', 'wedding'];

ReactDOM.render(
    <AllResorts
        activityNamesUsing={activityNamesUsing}
        rates={ratesJSON}
        resorts={resorts}
        staticActivities={staticActivities}
        features={features}
        slideImages={slideImages}
        filterData={filterData}
        questionsAnswersWithResorts={questionsAnswersWithResorts}
        countryCodes={countryCodes()}
        questionPopups= {questionPopups}
        stickyCheck
    />,
    document.getElementById('react-inject')
);